export default __webpack_public_path__ + "e6e80c3d504455aeb5f90984955093d9.png";